// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationDrawerProvider_wrapper__Gz1ul"};